import type { Group, Color, SizeRange, SettingsInterface } from './types'
import { scaleBand, scaleSqrt } from 'd3-scale'

export class Settings implements SettingsInterface {
  public groups: Group[]
  public colors: Color[]
  public sizes: { extent: SizeRange, radius: SizeRange }

  constructor (settings: SettingsInterface, application: Application) {
    this.groups = settings.groups
    this.colors = settings.colors
    this.sizes = settings.sizes
  }

  public initialXPosition (groupId: string, width: number, xOffset: number): number {
    if (groupId === null || groupId === undefined) return this.defaultXPosition
    return scaleBand()
      .domain(this.groupIds)
      .range([0, width])(groupId) as number + xOffset
  }

  public initialYPosition (groupId: string, height: number): number {
    if (groupId === null || groupId === undefined) return this.defaultYPosition
    return height / 2
  }

  private radius (size: number): number {
    if (this.noSizes || size === null) return 2.5
    return scaleSqrt().domain([this.sizes.extent.min, this.sizes.extent.max]).range([this.sizes.radius.min, this.sizes.radius.max]).clamp(true)(size)
  }

  get groupIds (): string[] {
    return this.groups.map(group => group.id)
  }

  get defaultGroup (): Group {
    return { id: 'default', name: 'Default' }
  }

  get defaultColor (): Color {
    return { id: 'default', colorString: '#000000', colorInt: 0x000000 }
  }

  get defaultSize (): number {
    return 2.5
  }

  get defaultXPosition (): number {
    return 0
  }

  get defaultYPosition (): number {
    return 0
  }

  get noSizes (): boolean {
    return this.sizes === undefined || this.sizes === null
  }
}
